import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, mergeProps as _mergeProps, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-ff19e296"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex navbar-desktop" }
const _hoisted_2 = { class: "navbar-mobile" }
const _hoisted_3 = { class: "d-flex flex-column" }

import { ref, computed, onMounted, onBeforeUnmount } from "vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'NavigationBar',
  setup(__props) {

const elevation = ref(0);
const scrollY = ref(0);
const menuActive = ref(false);
const drawer = ref(false);

const appBarClass = computed(() => ({
  "transparent-toolbar": scrollY.value === 0,
  "blurred-toolbar": scrollY.value > 0,
}));

const handleScroll = () => {
  scrollY.value = window.scrollY;
  elevation.value = scrollY.value > 0 ? 2 : 0;
};

onMounted(() => {
  window.addEventListener("scroll", handleScroll);
});

onBeforeUnmount(() => {
  window.removeEventListener("scroll", handleScroll);
});

return (_ctx: any,_cache: any) => {
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_expansion_panel_title = _resolveComponent("v-expansion-panel-title")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_expansion_panel_text = _resolveComponent("v-expansion-panel-text")!
  const _component_v_expansion_panel = _resolveComponent("v-expansion-panel")!
  const _component_v_expansion_panels = _resolveComponent("v-expansion-panels")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!

  return (_openBlock(), _createBlock(_component_v_app_bar, {
    elevation: elevation.value,
    class: _normalizeClass(appBarClass.value)
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_container, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_row, {
            align: "center",
            width: "100%"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_btn, {
                color: "transparent",
                elevation: 0,
                to: "/"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_img, {
                    class: "rounded-image mr-4",
                    src: _imports_0,
                    alt: "Logo",
                    "max-width": "40",
                    "max-height": "40"
                  }),
                  _createVNode(_component_v_toolbar_title, { class: "navbar--title" }, {
                    default: _withCtx(() => [
                      _createTextVNode("ANGIE")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_v_spacer),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_btn, {
                  class: "navbar--button",
                  to: "/"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("HOME")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  class: "navbar--button",
                  to: "/news"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("NEWS")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  class: "navbar--button",
                  to: "/partners"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("NETWORK")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_menu, {
                  class: "navbar--dropdown",
                  "offset-y": ""
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps({ class: "navbar--button" }, props, {
                      onClick: _cache[0] || (_cache[0] = ($event: any) => (menuActive.value = !menuActive.value))
                    }), {
                      default: _withCtx(() => [
                        _createTextVNode(" IMPLEMENTATION "),
                        _createVNode(_component_v_icon, {
                          class: "ml-1",
                          small: ""
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(menuActive.value ? "mdi-chevron-up" : "mdi-chevron-down"), 1)
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_list, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list_item, { to: "/objectives" }, {
                          default: _withCtx(() => [
                            _createTextVNode("OBJECTIVES")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item, { to: "/activities" }, {
                          default: _withCtx(() => [
                            _createTextVNode("ACTIVITIES")
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_list_item, { to: "/outputs" }, {
                          default: _withCtx(() => [
                            _createTextVNode("OUTPUTS")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  class: "navbar--button",
                  to: "/media"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("MEDIA")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_btn, {
                  class: "navbar--button",
                  to: "/contact"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("CONTACT")
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_dialog, {
                  transition: "dialog-top-transition",
                  fullscreen: ""
                }, {
                  activator: _withCtx(({ props }) => [
                    _createVNode(_component_v_btn, _mergeProps({
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (drawer.value = !drawer.value)),
                      class: "navbar--button",
                      icon: "",
                      large: "",
                      color: "black"
                    }, props), {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "menu-button" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-menu")
                          ]),
                          _: 1
                        })
                      ]),
                      _: 2
                    }, 1040)
                  ]),
                  default: _withCtx(({ isActive }) => [
                    _createVNode(_component_v_card, {
                      color: "transparent",
                      style: {"backdrop-filter":"blur(20px)"}
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_toolbar, {
                          color: "transparent",
                          class: "nav-toolbar"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_btn, {
                              onClick: ($event: any) => (isActive.value = false)
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, {
                                  size: "x-large",
                                  class: "menu-button"
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-close-circle-outline")
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 2
                            }, 1032, ["onClick"])
                          ]),
                          _: 2
                        }, 1024),
                        _createVNode(_component_v_card_text, null, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createVNode(_component_v_btn, {
                                color: "transparent",
                                elevation: 0,
                                to: "/",
                                onClick: ($event: any) => (isActive.value = false),
                                class: "menu-button--text"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("HOME")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_v_btn, {
                                color: "transparent",
                                elevation: 0,
                                to: "/news",
                                onClick: ($event: any) => (isActive.value = false),
                                class: "menu-button--text"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("NEWS")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_v_btn, {
                                color: "transparent",
                                elevation: 0,
                                to: "/partners",
                                onClick: ($event: any) => (isActive.value = false),
                                class: "menu-button--text"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("NETWORK")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_v_expansion_panels, null, {
                                default: _withCtx(() => [
                                  _createVNode(_component_v_expansion_panel, {
                                    elevation: "0",
                                    "bg-color": "transparent",
                                    class: "navbar--dropdown"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_expansion_panel_title, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, { "no-gutters": "" }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(" IMPLEMENTATION ")
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      }),
                                      _createVNode(_component_v_expansion_panel_text, null, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_col, null, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_list_item, {
                                                    elevation: 0,
                                                    to: "/objectives",
                                                    class: "menu-button--text",
                                                    onClick: ($event: any) => (isActive.value = false)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("OBJECTIVES")
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]),
                                                  _createVNode(_component_v_list_item, {
                                                    elevation: 0,
                                                    to: "/activities",
                                                    class: "menu-button--text",
                                                    onClick: ($event: any) => (isActive.value = false)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("ACTIVITIES")
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"]),
                                                  _createVNode(_component_v_list_item, {
                                                    elevation: 0,
                                                    to: "/outputs",
                                                    class: "menu-button--text",
                                                    onClick: ($event: any) => (isActive.value = false)
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("OUTPUTS")
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["onClick"])
                                                ]),
                                                _: 2
                                              }, 1024)
                                            ]),
                                            _: 2
                                          }, 1024)
                                        ]),
                                        _: 2
                                      }, 1024)
                                    ]),
                                    _: 2
                                  }, 1024)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(_component_v_btn, {
                                elevation: 0,
                                color: "transparent",
                                class: "menu-button--text",
                                to: "/media",
                                onClick: ($event: any) => (isActive.value = false)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("MEDIA")
                                ]),
                                _: 2
                              }, 1032, ["onClick"]),
                              _createVNode(_component_v_btn, {
                                elevation: 0,
                                color: "transparent",
                                class: "menu-button--text",
                                to: "/contact",
                                onClick: ($event: any) => (isActive.value = false)
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("CONTACT")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])
                          ]),
                          _: 2
                        }, 1024)
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["elevation", "class"]))
}
}

})